import { tv } from '~/utils/tv'

export const helperTextStyles = tv({
  base: [
    'flex w-full items-start gap-x-[var(--spacing-inline-onepulse)] px-[var(--padding-inset-onepulse)]',
    'font-semibold text-[length:var(--font-size-threepulse)] text-[var(--color-text-neutral-alternative)]',
  ],
  variants: {
    isError: {
      true: 'text-[var(--color-text-danger-alternative)]',
    },
    isDisabled: {
      true: 'text-[var(--color-text-neutral-disabled)]',
    },
    isReadOnly: {
      true: 'text-[var(--color-text-neutral-readonly)]',
    },
  },
  defaultVariants: {
    isError: false,
    isDisabled: false,
    isReadOnly: false,
  },
})
